import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/learninghub.css';

const LearningHubCards = () => {
  const navigate = useNavigate();
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleCardClick = (path) => {
    navigate(path);
  };

  return (
    <Container className="py-5 ">
      <Row>
        <h2 className="text-center fw-bold text-decoration-underline" >Practical Hub Knowledge Section </h2>
        {/* Learning Hub Card */}
        <Col md={6} className="my-3" >
          <Card 
            className={`hub-card learning-hub  ${hoveredCard === 'learning' ? 'hovered' : ''}`}
            onClick={() => handleCardClick('/learning-hub')}
            onMouseEnter={() => setHoveredCard('learning')}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <Card.Body>
              <div className="card-icon-wrapper">
                <i className="bi bi-book-half card-icon"></i>
              </div>
              <Card.Title className="text-center  text-white mb-3">Learning Hub</Card.Title>
              <Card.Text className="text-white fw-bolder fs-4" >
                Access tutorials, courses, and educational resources to enhance your skills and knowledge.
              </Card.Text>
              <div className="">
                <Button className="btn bg-dark mx-auto justify-content-center d-flex w-50" > Start Learning Today </Button>
                <p>Coming Soon...</p>


              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Knowledge Hub Card */}
        <Col md={6} className="my-3">
          <Card 
            className={`hub-card knowledge-hub   ${hoveredCard === 'knowledge' ? 'hovered' : ''}`}
            onClick={() => handleCardClick('/knowledge-hub')}
            onMouseEnter={() => setHoveredCard('knowledge')}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <Card.Body>
              <div className="card-icon-wrapper">
                <i className="bi bi-journal-text card-icon"></i>
              </div>
              <Card.Title className="text-center text-white fw-bolder mb-3">Knowledge Hub</Card.Title>
              <Card.Text className="text-white fw-bolder fs-4" >
                Discover Live Coding Practices knowledge based and reference materials.
              </Card.Text>
              <div className="">
                <Button className="btn bg-dark mx-auto justify-content-center w-50 d-flex " href="/knowledge_hub" > Explore Knowledge Hub </Button>
                <p>Coming Soon</p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LearningHubCards;